// Слайдер главной страницы (.slider): бесконечная лента, точки, без стрелок, автопрокрутка. Повторяет
// slick 1.5.9 с настройками сайта: разметка, классы, стили, таймеры, перетаскивание и клавиши те же
// (под них написаны стили тем); роли точек и слайдов — как в slick 1.8.1. Лента сдвигается за 500 мс.
// Фото слайдов ждут в data-sd-slide-src: загружается текущий слайд, соседние — при касании или
// нажатии, следующий — за секунду до автопрокрутки. Фото скрытого слайдера и слайдера под
// баннером приложения (#hideAppsFullSizeBanner) не загружаются.
import { $ } from './dollar';

const SLIDE_SRC = 'data-sd-slide-src';
const SPEED = 500;
let uid = 0;

export function createSlider(slider, { autoplaySpeed = 20000 } = {}) {
    if (slider.classList.contains('slick-initialized')) return slider.sdSlider;
    const doc = slider.ownerDocument;
    const win = doc.defaultView;
    const id = uid++;
    const slides = Array.from(slider.children);
    const count = slides.length;
    let current = 0;
    let animating = false;
    let paused = false;
    let timer = null;
    let preloadTimer = null;
    let slideWidth = 0;
    let listWidth = 0;
    let swipeLeft = null;
    let touch = {};
    let dragging = false;
    let shouldClick = true;
    let windowWidth = 0;
    let resizeTimer = null;

    slider.classList.add('slick-initialized');
    slides.forEach((slide, i) => {
        slide.classList.add('slick-slide');
        slide.setAttribute('data-slick-index', i);
    });
    slider.classList.add('slick-slider');
    const track = doc.createElement('div');
    track.className = 'slick-track';
    const list = doc.createElement('div');
    list.setAttribute('aria-live', 'polite');
    list.className = 'slick-list';
    slider.insertBefore(list, slides[0] || null);
    list.appendChild(track);
    slides.forEach(slide => track.appendChild(slide));
    track.style.opacity = '0';

    // Копии по краям ленты без id, как у slick в браузере; id внутри копий пустые.
    function clone(slide, index) {
        const copy = slide.cloneNode(true);
        copy.removeAttribute('id');
        copy.setAttribute('data-slick-index', index);
        copy.classList.add('slick-cloned');
        copy.querySelectorAll('[id]').forEach(node => node.setAttribute('id', ''));
        return copy;
    }
    if (count > 1) {
        track.insertBefore(clone(slides[count - 1], -1), track.firstChild);
        track.appendChild(clone(slides[0], count));
    }

    let dots = null;
    if (count > 1) {
        dots = doc.createElement('ul');
        dots.className = 'slick-dots';
        dots.innerHTML = slides.map((s, i) => '<li><button type="button" data-role="none" role="button" tabindex="0">' + (i + 1) + '</button></li>').join('');
        slider.appendChild(dots);
        dots.firstElementChild.classList.add('slick-active');
    }
    const allSlides = () => Array.from(track.children);
    const clones = () => allSlides().filter(slide => slide.classList.contains('slick-cloned'));

    function updateDots() {
        if (!dots) return;
        Array.from(dots.children).forEach((li, i) => {
            li.classList.remove('slick-active');
            if (i === current) li.classList.add('slick-active');
            if (dots.getAttribute('role') === 'tablist') {
                li.querySelector('button').setAttribute('aria-selected', i === current ? 'true' : 'false');
            }
        });
    }

    function setSlideClasses() {
        const all = allSlides();
        all.forEach(slide => {
            slide.classList.remove('slick-active', 'slick-center', 'slick-current');
            slide.setAttribute('aria-hidden', 'true');
        });
        if (!count) return;
        slides[current].classList.add('slick-current');
        if (count <= 1) {
            all.forEach(slide => { slide.classList.add('slick-active'); slide.setAttribute('aria-hidden', 'false'); });
        } else {
            slides[current].classList.add('slick-active');
            slides[current].setAttribute('aria-hidden', 'false');
        }
    }

    function initADA() {
        allSlides().forEach(slide => {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1');
            slide.querySelectorAll('a, input, button, select').forEach(node => node.setAttribute('tabindex', '-1'));
        });
        clones().forEach(slide => { slide.removeAttribute('role'); slide.removeAttribute('aria-describedby'); });
        if (dots) {
            slides.forEach((slide, i) => {
                if (!slide.getAttribute('id')) slide.setAttribute('id', 'slick-slide' + id + i);
                slide.setAttribute('role', 'tabpanel');
                slide.setAttribute('aria-describedby', 'slick-slide-control' + id + i);
            });
            dots.setAttribute('role', 'tablist');
            Array.from(dots.children).forEach((li, i) => {
                li.setAttribute('role', 'presentation');
                const button = li.querySelector('button');
                button.setAttribute('role', 'tab');
                button.setAttribute('id', 'slick-slide-control' + id + i);
                button.setAttribute('aria-controls', slides[i].getAttribute('id'));
            });
            updateDots();
        }
        track.querySelectorAll('.slick-active').forEach(slide => {
            slide.setAttribute('aria-hidden', 'false');
            slide.querySelectorAll('a, input, button, select').forEach(node => node.setAttribute('tabindex', '0'));
        });
    }

    const leftOf = index => (count > 1 ? -(index + 1) * slideWidth : 0);

    // Размеры ленты и слайдов по ширине списка, как setDimensions в slick (размеры — как в jQuery).
    function setPosition() {
        listWidth = $(list).width();
        slideWidth = Math.ceil(listWidth);
        const all = allSlides();
        $(track).width(Math.ceil(slideWidth * all.length));
        if (slides[0]) {
            const style = win.getComputedStyle(slides[0]);
            const offset = (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0)
                + (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0)
                + (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.borderRightWidth) || 0);
            $(all).width(slideWidth - offset);
        }
        track.style.left = leftOf(current) + 'px';
        loadSlides([current]);
    }

    // Слайдер виден: он и его родители показаны, а баннер приложения на экране его не закрывает.
    function visible() {
        const shown = node => {
            for (; node && node.nodeType === 1; node = node.parentElement) {
                const style = win.getComputedStyle(node);
                if (node.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
            }
            return true;
        };
        if (!doc.documentElement.contains(slider) || !shown(slider)) return false;
        const banner = doc.getElementById('hideAppsFullSizeBanner');
        if (!banner || banner.contains(slider) || !shown(banner) || win.getComputedStyle(banner).opacity === '0') return true;
        const rect = banner.getBoundingClientRect();
        return !(rect.bottom > rect.top && rect.right > rect.left && rect.bottom >= 0 && rect.right >= 0
            && rect.top <= (win.innerHeight || doc.documentElement.clientHeight) && rect.left <= (win.innerWidth || doc.documentElement.clientWidth));
    }

    // Фото слайдов с этими номерами и всех их копий по краям ленты.
    function loadSlides(indexes) {
        if (!count || !visible()) return;
        const wanted = new Set(indexes.map(index => ((index % count) + count) % count));
        allSlides().forEach(slide => {
            const index = parseInt(slide.getAttribute('data-slick-index'), 10);
            if (!wanted.has(((index % count) + count) % count)) return;
            slide.querySelectorAll('img[' + SLIDE_SRC + ']').forEach(image => {
                const url = image.getAttribute(SLIDE_SRC);
                if (!url || url.indexOf('[[') !== -1) return;
                image.removeAttribute('loading');
                image.setAttribute('src', url);
                image.removeAttribute(SLIDE_SRC);
            });
        });
    }

    function loadRange(from, to) {
        const indexes = [];
        for (let i = Math.min(from, to); i <= Math.max(from, to); i++) indexes.push(i);
        loadSlides(indexes);
    }

    // Фото следующего слайда загружаются за секунду до автопрокрутки.
    function schedulePreload() {
        win.clearTimeout(preloadTimer);
        if (count <= 1) return;
        preloadTimer = win.setTimeout(() => {
            if (!paused) loadSlides([current + 1]);
        }, Math.max(0, autoplaySpeed - 1000));
    }

    function autoPlay() {
        win.clearInterval(timer);
        if (count > 1 && !paused) timer = win.setInterval(() => slideTo(current + 1), autoplaySpeed);
    }

    function setPaused(value) {
        paused = value;
        if (value) win.clearInterval(timer);
        else autoPlay();
    }

    // Равномерный сдвиг ленты за 500 мс, как $.fn.animate с easing linear.
    function animate(target, done) {
        const start = parseFloat(track.style.left) || 0;
        const began = win.performance.now();
        function step(now) {
            const progress = Math.min(1, Math.max(0, now - began) / SPEED);
            track.style.left = (start + (target - start) * progress) + 'px';
            if (progress < 1) win.requestAnimationFrame(step);
            else done();
        }
        win.requestAnimationFrame(step);
    }

    function slideTo(index) {
        if (animating || count <= 1) return;
        const target = index < 0 ? count + index : (index >= count ? index - count : index);
        win.clearInterval(timer);
        animating = true;
        // Фото всех слайдов, которые лента пройдёт, нужны до начала движения.
        loadRange(current, index);
        current = target;
        setSlideClasses();
        updateDots();
        animate(leftOf(index), () => {
            animating = false;
            setPosition();
            swipeLeft = null;
            if (!paused) autoPlay();
            initADA();
            schedulePreload();
        });
    }

    function direction() {
        const angle = Math.round(Math.atan2(touch.startY - touch.curY, touch.startX - touch.curX) * 180 / Math.PI);
        const degrees = angle < 0 ? 360 - Math.abs(angle) : angle;
        if (degrees <= 45 || degrees >= 315) return 'left';
        if (degrees >= 135 && degrees <= 225) return 'right';
        return 'vertical';
    }

    function point(event) {
        const touches = event.touches;
        return touches ? { x: touches[0].pageX, y: touches[0].pageY, count: touches.length } : { x: event.clientX, y: event.clientY, count: 1 };
    }

    function swipeStart(event) {
        const p = point(event);
        if (p.count !== 1 || count <= 1) { touch = {}; return; }
        touch = { startX: p.x, curX: p.x, startY: p.y, curY: p.y };
        dragging = true;
    }

    function swipeMove(event) {
        const p = event.touches ? point(event) : null;
        if (!dragging || (p && p.count !== 1)) return;
        touch.curX = p ? p.x : event.clientX;
        touch.curY = p ? p.y : event.clientY;
        touch.length = Math.round(Math.abs(touch.curX - touch.startX));
        if (direction() === 'vertical') return;
        // Ни прокрутка страницы пальцем, ни выделение текста мышью не мешают перетаскиванию.
        if (touch.length > 4) event.preventDefault();
        if (animating) { swipeLeft = null; return; }
        swipeLeft = leftOf(current) + touch.length * (touch.curX > touch.startX ? 1 : -1);
        track.style.left = swipeLeft + 'px';
    }

    function swipeEnd() {
        dragging = false;
        shouldClick = !(touch.length > 10);
        if (touch.curX === undefined) return;
        if (touch.length >= listWidth / 5) {
            const side = direction();
            if (side === 'left') slideTo(current + 1);
            if (side === 'right') slideTo(current - 1);
        } else if (touch.startX !== touch.curX) {
            slideTo(current);
        }
        touch = {};
    }

    setSlideClasses();
    updateDots();
    list.classList.add('draggable');
    if (dots) $(dots).hide();
    slider.classList.add('slick-loading');
    initADA();
    setPosition();
    track.style.opacity = '1';
    slider.classList.remove('slick-loading');
    if (dots) $(dots).show();
    autoPlay();
    schedulePreload();

    if (dots) {
        Array.from(dots.children).forEach((li, i) => li.addEventListener('click', () => {
            loadRange(current, i);
            slideTo(i);
            li.querySelector('button').focus();
        }));
    }
    ['touchstart', 'mousedown'].forEach(type => list.addEventListener(type, swipeStart));
    ['touchmove', 'mousemove'].forEach(type => list.addEventListener(type, swipeMove));
    ['touchend', 'mouseup', 'touchcancel', 'mouseleave'].forEach(type => list.addEventListener(type, swipeEnd));
    list.addEventListener('click', event => {
        if (!shouldClick) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    });
    list.addEventListener('mouseenter', () => setPaused(true));
    list.addEventListener('mouseleave', () => setPaused(false));
    // Нажатие на точку: нужны фото слайдов до выбранного. Касание, нажатие или фокус в другом месте
    // слайдера: соседние слайды могут появиться сразу.
    ['pointerdown', 'mousedown', 'touchstart', 'focusin', 'keydown'].forEach(type => slider.addEventListener(type, event => {
        const dot = dots && event.target.closest && event.target.closest('.slick-dots li');
        if (dot && dots.contains(dot)) loadRange(current, Array.prototype.indexOf.call(dots.children, dot));
        else loadSlides([current - 1, current + 1]);
    }, true));
    list.addEventListener('keydown', event => {
        if (/TEXTAREA|INPUT|SELECT/.test(event.target.tagName)) return;
        if (event.keyCode === 37) slideTo(current - 1);
        if (event.keyCode === 39) slideTo(current + 1);
    });
    track.querySelectorAll('*').forEach(node => {
        if (node.getAttribute('draggable') !== 'true') node.addEventListener('dragstart', event => event.preventDefault());
    });
    doc.addEventListener('visibilitychange', () => setPaused(doc.hidden));
    win.addEventListener('resize', () => {
        // Слайдер мог стать видимым (смена ширины): фото текущего слайда нужны сразу, размеры — через 50 мс.
        loadSlides([current]);
        if (doc.documentElement.clientWidth === windowWidth) return;
        win.clearTimeout(resizeTimer);
        resizeTimer = win.setTimeout(() => {
            windowWidth = doc.documentElement.clientWidth;
            setPosition();
        }, 50);
    });
    win.addEventListener('orientationchange', setPosition);
    win.addEventListener('load', setPosition);
    // Как событие ready у slick: размеры ещё раз после всех обработчиков готовности документа.
    win.setTimeout(setPosition, 0);
    // Баннер приложения закрыли или убрали: фото текущего слайда загружаются сразу.
    const banner = doc.getElementById('hideAppsFullSizeBanner');
    if (banner && win.MutationObserver) {
        const observer = new win.MutationObserver(() => loadSlides([current]));
        observer.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        if (banner.parentNode) observer.observe(banner.parentNode, { childList: true });
    }

    slider.sdSlider = { setPosition };
    return slider.sdSlider;
}
